import React from 'react';
import axios from 'axios';
import qs from 'qs';
import { withSnackbar } from 'notistack';
import { withStyles } from '@material-ui/core/styles';
import Badge from '@material-ui/core/Badge';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import MessageThreadsEntriesList from './MessageThreadsEntriesList';

const StyledBadge = withStyles((theme) => ({
  badge: {
    right: -2,
    top: 15,
  },
}))(Badge);

const styles = () => ({
  heading: {
    fontSize: 16,
    color: '#616161',
    padding: '16px 16px 0',
  },
});

class MessageThreadsListWrapper extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loadedListIds: {},
      openListIds: [],
      modifiedEntries: {}, // this is basically a list of updated entries, whose data was changed later by ajax pull
    };

    this.axiosCancel = null;

    this.onListToggleClick = this.onListToggleClick.bind(this);
    this.onEntryClick = this.onEntryClick.bind(this);
    this.onSubEntryClick = this.onSubEntryClick.bind(this);
  }

  componentDidMount() {
    // Hacky workound for the ref issue -
    // throws that function components can't be given refs,
    // but the component is a class component. Guess a bug in react?
    // See: https://github.com/reactjs/reactjs.org/issues/2120
    const { childRef } = this.props;
    childRef(this);
  }

  componentWillUnmount() {
    const { childRef } = this.props;
    childRef(null);

    if (this.axiosCancel) {
      this.axiosCancel();
    }
  }

  onListToggleClick(id, entry, force) {
    const {
      loadedListIds,
      openListIds,
      modifiedEntries,
    } = this.state;
    const {
      enqueueSnackbar,
      listType,
      entries,
    } = this.props;

    if (
      appType === 'teacher_admin' &&
      typeof loadedListIds[id] === 'undefined'
    ) {
      axios
        .post(
          `${window.apiMessagingUrl}/getallthreadsforteacher`,
          qs.stringify({
            type: listType,
            teacher_id: entry.id,
          }),
          {
            cancelToken: new axios.CancelToken((c) => { this.axiosCancel = c }),
          }
        )
        .then((response) => {
          if (response.data.error) {
            enqueueSnackbar(response.data.error, {
              variant: 'error',
              autoHideDuration: 2000,
            });
          } else {
            let newModifiedEntries = { ...modifiedEntries };
            let newLoadedListIds = { ...loadedListIds };

            for (let i = 0; i < entries.length; i++) {
              if (entries[i].id === entry.id) {
                newModifiedEntries[entry.id] = response.data.data;
                break;
              }
            }

            newLoadedListIds[id] = true;

            this.setState({
              modifiedEntries: newModifiedEntries,
              loadedListIds: newLoadedListIds,
            });
          }
        })
        .catch((thrown) => {});
    }

    const index = openListIds.indexOf(id);

    if (typeof force === 'undefined') {
      if (index === -1) {
        openListIds.push(id);
      } else {
        openListIds.splice(index, 1);
      }
    } else if (
      force === true &&
      index === -1
    ) {
      openListIds.push(id);
    } else if (
      force === false &&
      index !== -1
    ) {
      openListIds.splice(id);
    }

    this.setState({
      openListIds,
    });
  }

  onEntryClick(entry) {
    this.props.onClick(entry);
  }

  onSubEntryClick(subEntry, entry) {
    if (subEntry) {
      if (appType === 'teacher') {
        // Attach the pupil, so we know it's a parent or pupil we selected
        subEntry.pupil_id = entry.id;
        subEntry.pupil_name = entry.name;
      }

      if (appType === 'teacher_admin') {
        // Attach the teacher, so we know it's a parent or pupil we selected
        subEntry.teacher_id = entry.id;
        subEntry.teacher_name = entry.name;
      }

      this.props.onClick(subEntry);
    }
  }

  getEntryId(entry) {
    return entry.thread
      ? entry.thread.id
      : 'id' + entry.id;
  }

  render() {
    const {
      classes,
      heading,
      type,
      listType,
      entries,
    } = this.props;
    const {
      modifiedEntries,
      openListIds,
    } = this.state;

    const isListTypeParent = listType === 'parent';
    const isTeacherAdmin = appType === 'teacher_admin';
    const hasSubEntries = (
      isListTypeParent ||
      isTeacherAdmin
    );
    const subEntriesKey = isTeacherAdmin && listType === 'pupil'
      ? 'pupils'
      : 'parents';

    return (
      <div className="message-threads-list-wrapper">
        <Typography
          className={classes.heading}
          variant="h6"
          component="h6"
        >
          {heading}
        </Typography>
        {hasSubEntries && (
          <>
            {entries.map((entry) => {
              if (modifiedEntries[entry.id]) {
                entry = modifiedEntries[entry.id];
              }

              const id = this.getEntryId(entry)
              const subEntries = entry[subEntriesKey];
              const isOpen = openListIds.indexOf(id) !== -1;

              let hasAnySubEntryNewMessages = false;
              subEntries.map((subEntry) => {
                if (
                  subEntry.thread &&
                  subEntry.thread.new_messages > 0
                ) {
                  hasAnySubEntryNewMessages = true;
                }
              });

              const subheaderContent = (
                <React.Fragment>
                  {hasAnySubEntryNewMessages && (
                    <StyledBadge
                      variant="dot"
                      color="secondary"
                    >
                      {entry.name}
                    </StyledBadge>
                  )}
                  {!hasAnySubEntryNewMessages && (
                    <span>{entry.name}</span>
                  )}
                  <IconButton
                    size="small"
                    onClick={this.onListToggleClick.bind(this, id, entry, undefined)}
                    className="toggle-button"
                  >
                    {isOpen ? <ExpandLess /> : <ExpandMore />}
                  </IconButton>
                </React.Fragment>
              );

              return (
                <MessageThreadsEntriesList
                  key={id}
                  type={type}
                  subheaderContent={subheaderContent}
                  parentEntry={entry}
                  entries={subEntries}
                  subEntriesKey={subEntriesKey}
                  showEntries={isOpen}
                  listType={listType}
                  onClick={(subEntry) => {
                    this.onSubEntryClick(subEntry, entry);
                  }}
                  useSuspense={false}
                />
              );
            })}
          </>
        )}
        {!hasSubEntries && (
          <MessageThreadsEntriesList
            type={type}
            parentEntry={null}
            entries={entries}
            subEntriesKey={null}
            showEntries={true}
            listType={listType}
            onClick={this.onEntryClick}
            useSuspense={false}
          />
        )}
      </div>
    );
  }
}

export default withSnackbar(withStyles(styles)(MessageThreadsListWrapper));
